import * as React from 'react';

const OptionBox: React.SFC<{
    children: React.ReactNode;
    onClose?: (event?: any) => void;
}> = ({ children }, onClose) => <div className="option-box">{children}</div>;

const OptionImageBox: React.SFC<{ image?: string }> = ({ image }) => (
    <div className="option-box--image">
        <div className="option-box--image-box">
            {image ? <img src={image} /> : <i className="nx nx-image-mb" />}
        </div>
    </div>
);

const OptionBoxWrapper: React.SFC<{ children: React.ReactNode }> = ({
    children
}) => <div className="option-box--options">{children}</div>;

const OptionGroupElement: React.SFC<{
    label: string | React.ReactNode;
    children?: React.ReactNode;
    error?: string;
    style?: any;
}> = ({ children, label, error, style }) => (
    <div className={`option-box--group${error ? ' error' : ''}`} style={style}>
        <div className="option-box--label">{label}</div>
        <div className="option-box--form-element">
            {children}
            {error ? (
                <span className="form-group__error-msg">{error}</span>
            ) : null}
        </div>
    </div>
);

export { OptionBox, OptionImageBox, OptionBoxWrapper, OptionGroupElement };
